const NotFound = () => {
  return (
    <section className="about | bg-gray padding-block-900">
    <div className="container">
        <div className="even-columns">
          <h1>Page not found</h1>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
